module.exports = __webpack_public_path__ + "static/media/palms-events-right.f00bede0.png";